export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  explorerLink: "nav-explorer-link",
  docsLink: "nav-docs-link",
  faucetLink: "nav-faucet-link",
  swapLink: "nav-swap-link",
  buyLink: "nav-buy-link",
  sellLink: "nav-sell-link",
  connectWalletBtn: "connect-wallet-btn",
  walletAddress: "wallet-address",
  walletBalance: "wallet-balance",
  disconnectBtn: "disconnect-wallet-btn",
  mobileMenuBtn: "mobile-menu-btn",
  statusLink: "nav-status-link",
  getStartedLink: "nav-get-started-link",
};

export const EXPLORER = {
  searchInput: "explorer-search-input",
  searchBtn: "explorer-search-btn",
  statsGrid: "explorer-stats-grid",
  latestBlocks: "latest-blocks-table",
  latestTxs: "latest-txs-table",
  blockNumber: "block-number",
  txHash: "tx-hash",
  demoBadge: "demo-data-badge",
};

export const BLOCK = {
  container: "block-detail-container",
  number: "block-detail-number",
  hash: "block-detail-hash",
  miner: "block-detail-miner",
  timestamp: "block-detail-timestamp",
  txCount: "block-detail-tx-count",
  txTable: "block-tx-table",
};

export const TX = {
  container: "tx-detail-container",
  hash: "tx-detail-hash",
  from: "tx-detail-from",
  to: "tx-detail-to",
  value: "tx-detail-value",
  status: "tx-detail-status",
  blockNumber: "tx-detail-block",
};

export const ADDRESS = {
  container: "address-detail-container",
  address: "address-detail-address",
  balance: "address-detail-balance",
  txCount: "address-detail-tx-count",
  txTable: "address-tx-table",
};

export const DOCS = {
  container: "docs-container",
  sidebar: "docs-sidebar",
  content: "docs-content",
  addMetamaskBtn: "add-metamask-btn",
};

export const FAUCET = {
  container: "faucet-container",
  addressInput: "faucet-address-input",
  requestBtn: "faucet-request-btn",
  txHash: "faucet-tx-hash",
  statusMessage: "faucet-status-message",
};

export const EXCHANGE = {
  container: "exchange-container",
  amountInput: "exchange-amount-input",
  fromTokenSelect: "exchange-from-token",
  toTokenSelect: "exchange-to-token",
  quoteBreakdown: "exchange-quote-breakdown",
  feeAmount: "exchange-fee-amount",
  feePercent: "exchange-fee-percent",
  taxAmount: "exchange-tax-amount",
  totalCost: "exchange-total-cost",
  outputAmount: "exchange-output-amount",
  submitBtn: "exchange-submit-btn",
  swapSubmit: "swap-submit",
};
